export default __webpack_public_path__ + "static/media/over-ons-over-ons.7f570a81.webp";